import { StyleSheet, Text, View, TouchableOpacity } from 'react-native';
import React from 'react';
import i18n from 'i18n-js';

import { scale } from '@components/frame';
import { isAndroid, localTime } from '@helpers';

import { font } from '@styles/fonts';
import Svg from '@styles/icons/svg';
import useManagePopup from '@components/machines/components/eventsChart/hooks/useManagePopup';
import { SCREEN_BORDER_RADIUS } from '@v2/pages/common/constants/base.constants';

export default (props) => {
  const { C, selectedItem, toGo, id } = props;
  const { loaded, chartHeight, popupWidth, popupLeft, lineLeft, time, isDay, name, color, linkConfig, showToGoButton } =
    useManagePopup(props);

  return (
    <View style={{ height: scale(81) }}>
      <View
        style={{
          width: popupWidth,
          height: scale(71),
          backgroundColor: C('Fill/Light/Quaternary'),
          borderColor: C('Fill/Light/Quaternary'),
          borderWidth: StyleSheet.hairlineWidth,
          borderRadius: scale(SCREEN_BORDER_RADIUS),
          paddingLeft: scale(8),
          left: popupLeft,
          marginTop: scale(9),
        }}
      >
        {showToGoButton && (
          <TouchableOpacity
            activeOpacity={1}
            onPress={(e) => {
              e.preventDefault();
              toGo(selectedItem);
            }}
            style={{ position: 'absolute', zIndex: 10000, top: scale(3), right: scale(4), borderRadius: scale(SCREEN_BORDER_RADIUS), backgroundColor: C('Fill/Light/Tertiary') }}
            href={isDay ? '' : `/machines?id=${id}&section=${linkConfig?.section}&date=${localTime(linkConfig?.date).format('YYYY-MM-DD HH:mm')}`}
          >
            <View>
              <Svg icon="togo" width={scale(20)} height={scale(20)} color="Label/Light/Tertiary" />
            </View>
          </TouchableOpacity>
        )}

        <Text
          style={[
            {
              color,
              marginTop: scale(2),
            },
            font['Button 2'],
          ]}
        >
          {i18n.t(name)}
        </Text>
        <View style={{ flexDirection: 'row', marginTop: scale(-2), opacity: loaded ? 1 : 0 }}>
          <Text
            style={[
              {
                color,
              },
              font['Large Title'],
            ]}
          >
            {Number(isDay ? time.m : time.h)}
            <Text
              style={[
                font['Button 1'],
                {
                  color,
                },
                isAndroid && { lineHeight: scale(36) },
              ]}
            >
              {i18n.t(isDay ? 'm' : 'h')}{' '}
            </Text>
          </Text>
          <Text
            style={[
              {
                color,
              },
              font['Large Title'],
            ]}
          >
            {Number(isDay ? time.s : time.m)}
            <Text
              style={[
                {
                  color,
                },
                font['Button 1'],
                isAndroid && { lineHeight: scale(36) },
              ]}
            >
              {i18n.t(isDay ? 's' : 'm')}
            </Text>
          </Text>
        </View>
        <Text
          style={[
            {
              color: C('Label/Light/Tertiary'),
              marginTop: scale(-1),
            },
            font['Button 1'],
          ]}
          numberOfLines={1}
          ellipsizeMode={'middle'}
        >
          {selectedItem.date}
        </Text>
      </View>
      <View
        style={{
          position: 'absolute',
          width: 1,
          backgroundColor: C('Label/Light/Tertiary'),
          height: chartHeight - (selectedItem.height / 100) * chartHeight + scale(4),
          top: scale(80),
          left: lineLeft,
          zIndex: 1000,
        }}
      />
    </View>
  );
};
